import { toast } from "react-toastify";

interface IPaymentCodContainerV2Props {
  value: string;
}

export const PaymentCodContainerV2 = ({
  value,
}: IPaymentCodContainerV2Props) => {
  async function copyToClipboard() {
    await navigator.clipboard.writeText(value);
    toast.info("Codigo copiado!");
  }

  return (
    <div className="flex h-11 w-full min-w-0 max-w-full items-center justify-between gap-2.5 rounded-[2px] bg-[#e8e8e8] px-4 sm:max-w-[372px] print:h-auto print:max-w-none print:py-2">
      <span className="min-w-0 truncate font-['Mulish'] text-sm text-[#20332f] print:overflow-visible print:whitespace-normal print:break-all print:truncate-none">
        {value}
      </span>
      <button type="button" onClick={copyToClipboard}>
        <img
          src="/assets/svgs/icon-copy-payment-code.svg"
          alt="copiar código"
          className="h-6 w-6 shrink-0"
        />
      </button>
    </div>
  );
};
